import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

export interface ISelectiveProcessDetailResource {
  resource_admin_id: string;
  resource_manager_id: string;
  selective_process_name: string;
  resource_type_name: string;
  resource_period: string;
  resource_by_candidate: IResourceByCandidate[];
  period_identification: string;
  resource_type_has_question: boolean;
  is_in_resource: boolean;
  instruction_to_candidates: string;
  has_update_or_delete: boolean;
}

export interface IResourceByCandidate {
  resource_id: string;
  resource_code: string;
  resource_created_at: string;
  status: string;
  proof_subject?: string;
  question?: string;
}

const RequestDetailResources = async (resourceId: string) => {
  if (isValidUUID(resourceId)) {
    const response = await configApi.get<ISelectiveProcessDetailResource>(`candidate-area/resource/${resourceId}/`);
    return response.data;
  }
};

export const useRequestDetailResources = (resourceId: string) => {
  return useQuery({
    queryKey: ['detail_resource', resourceId],
    queryFn: () => RequestDetailResources(resourceId),
    refetchOnWindowFocus: false,
  });
};
